export class DialogModelNewComposition {
    constructor(
      public data:any
    ) {}
  }